import { createApp } from 'vue'
import App from './templates/App.vue'
// import router from './router/index'

import Maska from 'maska'
import api from './scripts/api.js'
import { createI18n } from 'vue-i18n'
import ru from '../locale/ru.json'
import kz from '../locale/kz.json'


const i18n = createI18n({
    locale: 'ru', // set locale
    fallbackLocale: 'ru', // set fallback locale
    messages: {
        kz: kz,
        ru: ru
    } // set locale messages
    // If you need to specify other options, you can set other options
    // ...
})

// createApp(App).use(router).mount('#vue-app-auth')

const app = createApp(App)

app.use(Maska);
app.use(i18n);
app.config.globalProperties.$api = api;

app.mount('#vue-app-auth')
